import { isBankDay, nextBankDay, prevBankDay } from './bankday';
import {
  formatDate,
  formatDateShort,
  formatDateLong,
  formatDayMonth,
  formatDayMonthLong,
  formatTime,
  formatDateTime,
  formatShortMonth,
  formatLongMonth,
  formatShortMonthFromIdx,
  formatLongMonthFromIdx,
  formatWeekday,
  formatMonthYear,
  formatMonthYearLong,
} from './date';
import { convertIetfLanguageTagToLocale } from './ietf';
import type { LocaleType as LocType } from './Locale';
import { Locale } from './Locale';
import { LocaleContext } from './LocaleContext';
import {
  formatInt,
  formatFloat,
  formatMoney,
  formatPercent,
  toInt,
  toFloat,
} from './number';
import { r } from './resource';
import { numberSettings } from './settings';
import { useLocalize } from './useLocalize';
import { useResource } from './useResource';

export type LocaleType = LocType;
export {
  LocaleContext,
  Locale,
  // format numbers
  formatInt,
  formatFloat,
  formatMoney,
  formatPercent,
  toInt,
  toFloat,
  // format date
  formatDate,
  formatDateShort,
  formatDateLong,
  formatDayMonth,
  formatDayMonthLong,
  formatTime,
  formatDateTime,
  formatShortMonth,
  formatLongMonth,
  formatShortMonthFromIdx,
  formatLongMonthFromIdx,
  formatWeekday,
  formatMonthYear,
  formatMonthYearLong,
  // bankday
  isBankDay,
  nextBankDay,
  prevBankDay,
  // resource
  r,
  useLocalize,
  useResource,
  numberSettings,
  convertIetfLanguageTagToLocale,
};
